<template>
  <el-dialog title="平仓" width="450px" v-model="dialogVisible" :close-on-click-modal="true" :before-close="cancledialog"
    draggable :modal="false">
    <el-form :model="form" v-loading="loading">
      <el-row :gutter="10" style="margin-bottom: 20px;">
        <el-col :span="24">
          <el-tag :type="form.posSide === constants.SHORT ? 'danger' : 'success'" size="large">
            {{ title }}
          </el-tag>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="24">
          <div class="labelClass">选择占比&nbsp;{{ percent }}%</div>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="24">
          <el-slider v-model="percent" :step="10" :min="10" :max="100" show-stops>
          </el-slider>
        </el-col>
      </el-row>
      <div class="note">
        将会触发市价委托平仓当前仓位
      </div>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="info" plain @click="cancledialog">取 消</el-button>
        <el-button type="warning" plain @click="submitAll()" :disabled="loading">市价全平</el-button>
        <el-button type="primary" plain @click="submitForm()" :disabled="loading">平 仓</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<style scoped>
.note {
  border-radius: 5px;
  color: #909399;
  background: #202121;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 12px;
}
</style>
<script setup>
import { ref, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import Decimal from 'decimal.js'
import * as constants from '@/utils/okxConstants'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const systemStore = useSystemStore()
const logStore = useLogStore()
const dialogVisible = ref(false)
const loading = ref(false)
const title = ref("")
const percent = ref(50)
const form = ref({
  posSide: "",
})

const init = (data) => {
  dialogVisible.value = true
  form.value = data
  title.value = `${data.instId.replace(/-SWAP|-/g, "")} SWAP ${(data.posSide === constants.SHORT ? '空' : '多')} ×${data.lever}`
}

const cancledialog = () => {
  dialogVisible.value = false
}

const submitAll = async () => {
  try {
    loading.value = true
    let _obj = {
      instId: form.value.instId,
      posSide: form.value.posSide,
      mgnMode: form.value.mgnMode,
      autoCxl: true
    }
    await systemStore.privateClient.closePosition(_obj)
    ElMessage.success('平仓成功')
    //emit("callGetOrders")
    loading.value = false
    dialogVisible.value = false
  } catch (error) {
    loading.value = false
    ElMessage.error('平仓失败' + error)
    logStore.addLog({
      title: '平仓失败',
      level: 'error',
      message: error
    })
  }
}

const submitForm = async () => {
  try {
    loading.value = true

    let symbol = systemStore.usymbols.find(x => x.symbol === form.value.instId)
    let ctVal = parseFloat(symbol.info.ctVal)     // 合约面值
    let minSz = parseFloat(symbol.info.minSz) // 最小下单数量 单位张
    let lotSz = parseFloat(symbol.info.lotSz)    // 下单数量精度 单位张

    let _percent = percent.value || 100
    _percent = _percent / 100

    let sz = new Decimal(form.value.availPos).times(_percent).toDecimalPlaces(2, Decimal.ROUND_FLOOR).toNumber()
    if (sz < minSz) sz = minSz

    //根据精度调整小数
    const szDecimalPlaces = lotSz.toString().split('.')[1]?.length || 0
    sz = new Decimal(sz).toDecimalPlaces(szDecimalPlaces, Decimal.ROUND_FLOOR).toNumber()

    let _obj = {
      instId: form.value.instId,
      tdMode: form.value.mgnMode,
      side: form.value.posSide === constants.SHORT ? constants.BUY : constants.SELL,
      posSide: form.value.posSide,
      sz: sz,
      ordType: "market",
    }
    await systemStore.privateClient.placeOrder(_obj)
    
    ElMessage.success('平仓成功')
    loading.value = false
    dialogVisible.value = false
  } catch (error) {
    loading.value = false
    ElMessage.error('平仓失败' + error)
    logStore.addLog({
      title: '平仓失败',
      level: 'error',
      message: error
    })
  }
}

defineExpose({ init })

</script>